import { AnimatePresence, motion } from "motion/react";
import { useEffect, useState } from "react";

import { Typed } from "~/components/Typed";

export const CycleLoadingText: React.FC<{
  messages: string[];
  delay: number;
}> = ({ messages, delay }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => prev + 1);
    }, delay);
    return () => {
      clearInterval(interval);
    };
  }, [delay]);

  const message = messages[index % messages.length];

  return (
    message && (
      <AnimatePresence mode="wait">
        <div className="flex gap-2" key={index}>
          <motion.div
            layoutId="loading"
            className="loading loading-dots loading-sm"
          />
          <Typed>{message}</Typed>
        </div>
      </AnimatePresence>
    )
  );
};
